'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import { useCookieConsent } from './CookieConsentProvider';

export function CookiePreferencesModal() {
  const { consent, preferencesOpen, closePreferences, updatePreferences, acceptAll } =
    useCookieConsent();
  const [analytics, setAnalytics] = useState(false);

  useEffect(() => {
    if (!preferencesOpen) return;
    setAnalytics(consent?.analytics ?? false);
  }, [preferencesOpen, consent]);

  if (!preferencesOpen) return null;

  return (
    <div
      className="cookie-modal cookie-modal--open"
      role="dialog"
      aria-label="Cookie preferences"
      onClick={(e) => {
        if (e.target === e.currentTarget) closePreferences();
      }}
    >
      <div className="cookie-modal__card">
        <h2>Cookie preferences</h2>
        <p className="text-muted">
          Choose which optional cookies we may use. Read our{' '}
          <Link href="/legal/cookies/">Cookie Policy</Link> for details.
        </p>

        <div className="cookie-modal__row">
          <div className="cookie-modal__row-text">
            <strong>Essential</strong>
            <p className="text-muted">
              Sign-in session, your theme settings, and storing your consent choice. Always on.
            </p>
          </div>
          <input type="checkbox" checked disabled aria-label="Essential cookies always enabled" />
        </div>

        <div className="cookie-modal__row">
          <div className="cookie-modal__row-text">
            <strong>Analytics</strong>
            <p className="text-muted">Firebase Analytics to understand how the site is used.</p>
          </div>
          <input
            type="checkbox"
            checked={analytics}
            onChange={(e) => setAnalytics(e.target.checked)}
            aria-label="Analytics cookies"
          />
        </div>

        <div className="cookie-modal__actions">
          <button type="button" className="btn btn-ghost" onClick={closePreferences}>
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => updatePreferences({ analytics })}
          >
            Save preferences
          </button>
          <button type="button" className="btn btn-primary" onClick={acceptAll}>
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}

/** Footer trigger — opens preferences without requiring the banner. */
export function CookieSettingsButton() {
  const { openPreferences } = useCookieConsent();
  return (
    <button type="button" className="paydirt-footer__cookie-settings" onClick={openPreferences}>
      Cookie settings
    </button>
  );
}
